import { FieldVariant } from '@shared/scenes/cards/collectionView/components/fields/FieldVariant';
import { API } from '@shared/types/api';

/**
 * The variant a desktop table cell (the collection view table and the subtable table) asks a
 * column's field for, by component type: numbers as plain, tabular text, and the default
 * otherwise until design picks which other compact shapes suit a table.
 */
const TABLE_CELL_VARIANTS: Partial<Record<API.ComponentType, FieldVariant>> = {
  NUMBER: 'compact',
};

export function getTableCellVariant(component: API.AnyComponent): FieldVariant {
  return TABLE_CELL_VARIANTS[component.type] ?? 'default';
}
